const API={
  data:{
    // 获取机构信息
    dataOrg:"/v1/data/org",
    // 登陆
    dataLogin:"/v1/data/login",
    // 预约选座-获取预约选座基础信息
    dataWreservationDay:"/v1/data/w/reservation/day",
    // 预约选座-根据房间获取座位信息
    dataWreservationSeatV:"/v1/data/w/reservation/seat/v2",
    // 预约选座-获取座位已经预约的时间段
    dataWreservationSeatTime:"/v1/data/w/reservation/seat/time",
    // 预约选座-预约座位
    dataWreservationSeatReservation:"/v1/data/w/reservation/seat/reservation",
    // 预约记录-查询我的预约记录
    dataWreservationHistory:"/v1/data/w/reservation/history",
    // 预约记录-签到
    dataWreservationSign:"/v1/data/w/reservation/sign",
    // 预约记录-座位-暂离
    dataWreservationUseLeave:"/v1/data/w/reservation/use-leave",
    // 预约记录-座位-结束使用座位
    dataWreservationUseEnd:"/v1/data/w/reservation/use-end",
    // 预约记录-座位-继续使用
    dataWreservationUseContinued:"/v1/data/w/reservation/use-continued",
    // 个人信息-获取个人信息
    dataWreservationMyInfo:"/v1/data/w/reservation/my-info",
    // 预约记录-取消预约记录
    dataWreservationCancel:"/v1/data/w/reservation/cancel",
    // 预约排行-获取预约排行
    dataWreservationRanking:"/v1/data/w/reservation/ranking"
  }
}
export default {
  API
}



// WEBPACK FOOTER //
// ./src/api/api.js